import { z } from 'zod';

export const GetCurationServiceRequestDtoSchema = z
  .object({
    curationId: z.string(),
  })
  .describe('GetCurationServiceRequestDtoSchema');

export type GetCurationServiceRequest = z.infer<typeof GetCurationServiceRequestDtoSchema>;

/** OpenAPI `CurationDetailV2SnapItem` */
export const CurationSnapItemServiceDtoSchema = z
  .object({
    id: z.string(),
    imageUrl: z.string(),
    linkUrl: z.string(),
  })
  .describe('CurationSnapItemServiceDtoSchema');

export const CurationGoodsItemServiceDtoSchema = z
  .object({
    goodsNo: z.string(),
    imageUrl: z.string(),
    isLiked: z.boolean(),
    brandNo: z.number(),
    brandName: z.string(),
    goodsName: z.string(),
    salesRate: z.number(),
    price: z.number(),
    expectedEarnings: z.number(),
    likeCount: z.number(),
    reviewScore: z.string(),
    reviewCount: z.number(),
    isSoldOut: z.boolean(),
    ordNo: z.number(),
    extraDiscountAmount: z.number().int().nullish(),
    finalPrice: z.number().int().nullish(),
    finalDiscount: z.number().int().nullish(),
    isLowestPrice: z.boolean().nullish(),
    isExclusive: z.boolean(),
    existsCoupon: z.boolean().nullish(),
    largeCategoryNo: z.number().optional().nullable(),
    largeCategoryName: z.string().optional().nullable(),
    middleCategoryNo: z.number().optional().nullable(),
    middleCategoryName: z.string().optional().nullable(),
    smallCategoryNo: z.number().optional().nullable(),
    smallCategoryName: z.string().optional().nullable(),
  })
  .describe('CurationGoodsItemServiceDtoSchema');

export const GetCurationServiceResponseDtoSchema = z
  .object({
    curationId: z.string(),
    title: z.string().min(1),
    description: z.string(),
    /** OpenAPI `GetCurationDetailV2Response.type` — GOODS, SNAP2 등 */
    type: z.string().nullish(),
    ordNo: z.number().min(0),
    goodsItems: z.array(CurationGoodsItemServiceDtoSchema),
    snapItems: z.array(CurationSnapItemServiceDtoSchema).default([]),
  })
  .describe('GetCurationServiceResponseDtoSchema');

export type GetCurationServiceResponse = z.infer<typeof GetCurationServiceResponseDtoSchema>;
export type CurationGoodsItem = z.infer<typeof CurationGoodsItemServiceDtoSchema>;
export type CurationSnapItem = z.infer<typeof CurationSnapItemServiceDtoSchema>;
